module.exports = __webpack_public_path__ + "static/media/dentista1.93a2e2a6.jpg";